import type { NotifyPort } from '@/features/messages/domain/notify'
import type { Department, DepartmentPort, OrgTeam, OrgTeamPort } from '../domain/member'

const listDepartments = async (port: DepartmentPort, notify: NotifyPort): Promise<Department[]> => {
	try {
		return await port.listDepartments()
	} catch {
		notify.error('hr.departmentsLoadFailed')
		return []
	}
}

const listOrgTeams = async (port: OrgTeamPort, notify: NotifyPort): Promise<OrgTeam[]> => {
	try {
		return await port.listTeams()
	} catch {
		notify.error('hr.teamsLoadFailed')
		return []
	}
}

export { listDepartments, listOrgTeams }
